import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../Common/ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';

@Injectable()
export class AdmManageProctorAlertConfigService {

  constructor(private _httpClient: IesHttpClient) { }

  getProctorAlertConfig(){
     return this._httpClient.get(AppUrl.getProctorAlertConfig);
  }

  updateProctorAlertConfig(params){
    return this._httpClient.put(AppUrl.updateProctorAlertConfig, params);
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-proctor-alert-config/adm-manage-proctor-alert-config.service.ts